import { Component, Input, Output, EventEmitter } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { faTrash, faTimes, faCog, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { ButtonComponent } from '../button/button.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-modal-delete-confirm',
  standalone: true,
  imports: [FontAwesomeModule, TranslateModule, ButtonComponent, FormsModule],
  templateUrl: './modal-delete-confirm.component.html',
  styleUrls: ['./modal-delete-confirm.component.scss']
})
export class ModalDeleteConfirmComponent {
  @Input() show = false;
  @Input() configKey: string = '';
  @Input() configType: string = '';
  @Input() impactItems: string[] = [];
  @Input() forceCheckboxLabel: string = '';
  @Input() forceCheckboxWarning: string = '';
  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<boolean>();

  faTrash = faTrash;
  faTimes = faTimes;
  faCog = faCog;
  faExclamationTriangle = faExclamationTriangle;

  forceDelete = false;

  onClose() {
    this.forceDelete = false;
    this.close.emit();
  }

  onConfirm() {
    this.confirm.emit(this.forceDelete);
    this.forceDelete = false;
  }
}